import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography, Divider, useMediaQuery } from "@mui/material";
import json2mq from "json2mq";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "cover", md: "100% 109%" },
    width: "100vw",
    background: "linear-gradient(to top, #04112b 0%, #061735 100%)",
    alignItems: "center",
  },
  footer: {
    background: theme.palette.blue.main,
  },
  mainText: {
    color: theme.palette.white.main,
    fontSize: { xs: "30px", md: "40px", lg: "45px" },
    lineHeight: { xs: "40px", md: "65px" },
    fontFamily: theme.typography.montserrat.light,
    mt: { xs: "43px", md: "150px" },
    textAlign: { xs: "center" },
    width: { xs: "240px", md: "800px", lg: "900px" },
  },
  mailText: {
    color: theme.palette.white.main,
    fontSize: { xs: "25px", md: "35px", lg: "40px" },
    lineHeight: { xs: "40px", md: "65px" },
    fontFamily: theme.typography.montserrat.light,
    mt: { xs: "15px", md: "30px" },
    textAlign: { xs: "center" },
    width: { xs: "290px", md: "850px", lg: "980px" },
  },
  secondaryText: {
    color: theme.palette.white.main,
    fontSize: { xs: "20px", md: "22px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    width: { xs: "240px", md: "800px" },
    mt: { xs: "56.2px" },
    mb: { xs: "70px" },
  },
  subtitle: {
    color: theme.palette.white.main,
    fontSize: { xs: "15px", md: "30px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    width: { xs: "230px", md: "auto" },
    mb: { xs: "70px" },
  },
  divider: {
    background: theme.palette.white.main,
    height: "0.5px",
    width: { xs: "211px", md: "850px", lg: "1210px" },
  },
  thanks: {
    color: theme.palette.white.main,
    fontSize: { md: "30px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    mt: { md: "57px" },
    mb: { md: "47.5px" },
    display: { xs: "none", md: "inherit" },
  },
});

const ApplyEmail = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [data] = useState(() => JSON.parse(localStorage.getItem("data")));
  const { pathname } = useLocation();
  const componentName = "ApplyEmail";
  const translation = useTranslation(pathname, componentName);
  const { title, img, description, disclaimer, emailNotReceived } = translation;

  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement) {
      focusOnElement();
    }
  });

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 900,
    })
  );

  const sm = useMediaQuery(
    json2mq({
      maxWidth: 1000,
      minWidth: 900,
    })
  );

  const md = useMediaQuery(
    json2mq({
      maxWidth: 1199,
      minWidth: 1000,
    })
  );

  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1200,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
      maxWidth: 1700,
    })
  );

  const xxl = useMediaQuery(
    json2mq({
      minWidth: 1701,
    })
  );

  const stylesHelper = () => {
    if (md || lg || sm || xl || xxl) {
      return {
        mainImage: { width: "330px", height: "250px", marginTop: "60px" },
      };
    } else if (xs) {
      return {
        mainImage: { width: "229px", height: "200px", marginTop: "20px" },
      };
    }
  };

  return (
    <>
      <Box sx={classes.container} ref={focusElement}>
        <Typography sx={classes.mainText}>
          <span style={{ fontWeight: "bold" }}>
            {data && data.cohortLabel.includes("BC")
              ? title.bootcamp
              : title.intro}
          </span>
        </Typography>

        <img
          src={img.src}
          alt={img.alt}
          style={stylesHelper() && stylesHelper().mainImage}
        />

        <Typography sx={classes.mailText}>
          {data && data.cohortLabel.includes("BC")
            ? description[7]
            : description[0]}
          <span style={{ fontWeight: "bold" }}>{description[1]}</span>
          {data && data.cohortLabel.includes("BC") ? (
            <>
              {description[2]}
              <b>{description[3]}</b>
              {description[4]}
            </>
          ) : (
            <>
              {description[5]}
              <b>{description[6]}</b>
            </>
          )}
        </Typography>
        <Typography sx={classes.subtitle}>{disclaimer}</Typography>

        <Divider sx={classes.divider} />

        <Typography sx={classes.secondaryText}>{emailNotReceived}</Typography>
      </Box>
    </>
  );
};

export default ApplyEmail;
